import React from 'react';
import './PageLayout.css';

const PageLayout = ({ children, title, subtitle }) => {
  return (
    <div className="page-layout">
      <main className="page-main">
        {title && (
          <section className="page-hero">
            <div className="page-hero-content">
              <h1 className="page-title">{title}</h1>
              {subtitle && <p className="page-subtitle">{subtitle}</p>}
            </div>
          </section>
        )}
        <div className="page-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default PageLayout;